import React, { useEffect, memo, useState, useRef } from 'react';
import './index.less';
import { ChildExamPointsStatusIcon, ExamPointsRightArrowIcon } from '@/svgs';
import { useAppStore } from '@/store';
import { IPredictionScoreExamPointDetail } from '@/types';
import globalStore from '@/store/global';
import { createPredictScoreExamPointPractice } from '@/apis';
import { IInitInfo } from '../..';

interface IProps {
    initInfo?: IInitInfo;
    detailData: IPredictionScoreExamPointDetail;
}

const ExamPointPractice = ({ detailData, initInfo }: IProps) => {
    const {
        themeStore: { theme },
    } = useAppStore();

    const handleGoToPractice = async (event: React.MouseEvent) => {
        if (!initInfo?.hasAllRequiredParams) return;

        // 继续做题
        if (detailData.submitStatus === 0 && detailData.paperDataLogId) {
            globalStore.publish('main-app', {
                type: 'gotoPractice',
                params: {
                    paperDataLogId: detailData.paperDataLogId,
                    knowledgeId: detailData.knowledgeId,
                },
            });
            return;
        }
        // 未做练习、已交卷
        const { projectId, subjectId, examSeasonId, sourceFromType, businessParam } = initInfo;
        const response = await createPredictScoreExamPointPractice({
            projectId,
            subjectId,
            examSeasonId,
            sourceFromType,
            knowledgeId: detailData.knowledgeId,
            knowledgeTitle: detailData.title,
            businessParam: businessParam ? { ...businessParam, knowledgeId: detailData.knowledgeId } : undefined,
        });
        if (response.status === 0 && response.result?.paperDataLogId) {
            globalStore.publish('main-app', {
                type: 'gotoPractice',
                params: {
                    paperDataLogId: response.result.paperDataLogId,
                    knowledgeId: detailData.knowledgeId,
                },
            });
        }
    };

    return (
        <div className="sub-tiku__exam-point-practice" onClick={handleGoToPractice}>
            {detailData.learnStatus === 1 ? (
                <>
                    <div className="sub-tiku__status-icon">
                        <img src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202503/03/824e9_20250303152739.png" />
                    </div>
                    <div className="sub-tiku__study-score completed">
                        已获得<span className="sub-tiku__study-score-em">{detailData.predictionScore}</span>分
                    </div>
                </>
            ) : (
                <>
                    <div className="sub-tiku__status-icon">
                        <ChildExamPointsStatusIcon color={theme.mainColor} />
                    </div>
                    <div className="sub-tiku__study-score">
                        <span className="sub-tiku__study-score-em">{detailData.predictionScore}</span>/{detailData.totalScore}分
                    </div>
                </>
            )}
            <div className="sub-tiku__mr-auto"></div>
            <div className="sub-tiku__question-count">
                {detailData.finishedQuestionCount}/{detailData.totalQuestionCount}
            </div>
            <ExamPointsRightArrowIcon />
        </div>
    );
};

export default memo(ExamPointPractice);
